import React from 'react'


export const Button = ({ variant = 'primary', className = '', children, ...props }) => (
  <button type="button" className={`btn btn-${variant} ${className}`} {...props}>
    {children}
  </button>
)
